import { quickTopics } from "@/mocks/home";

export default function HotBar() {
  const doubled = [...quickTopics, ...quickTopics];
  return (
    <div className="w-full border-y border-primary-950/10 bg-accent-500 text-primary-950">
      <div className="shell flex items-center gap-4 py-2.5">
        <span className="flex shrink-0 items-center gap-1.5 font-label text-xs font-black uppercase tracking-widest text-primary-950">
          <i className="ri-flashlight-fill text-base" aria-hidden="true" />
          快讯流
        </span>
        <div className="relative min-w-0 flex-1 overflow-hidden marquee-mask">
          <div className="flex w-max animate-marquee items-center gap-8 whitespace-nowrap">
            {doubled.map((t, i) => (
              <span key={i} className="flex items-center gap-2 text-sm font-medium text-primary-950">
                <i className="ri-arrow-right-s-line text-base" aria-hidden="true" />
                {t}
              </span>
            ))}
          </div>
        </div>
        <a
          href="#feed"
          className="hidden shrink-0 items-center gap-1 text-sm font-bold text-primary-950 hover:text-primary-900 sm:inline-flex cursor-pointer whitespace-nowrap"
        >
          全部快讯
          <i className="ri-arrow-right-up-line" aria-hidden="true" />
        </a>
      </div>
    </div>
  );
}